import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { defaultColorOpacity } from '../constants/default';

export const useUserColors = () => {
  const userColorPrimary = useSelector(state => state.Event.event.primaryColor);
  const userColorOpacity = useSelector(state => state.Event.event.primaryColorOpacity);

  useEffect(() => {
    // Poziom przezroczystości tła paska; brak wartości => domyślna.
    const opacity = (userColorOpacity === null || userColorOpacity === undefined) ? defaultColorOpacity : userColorOpacity;
    // Obramowanie w tym samym kolorze, zawsze wyraźniejsze od tła (+0.4, max 1).
    const borderAlpha = Math.min(opacity + 0.4, 1);

    // Znajdź lub stwórz element <style> dla dynamicznych klas
    let styleElement = document.getElementById('user-custom-colors');

    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = 'user-custom-colors';
      document.head.appendChild(styleElement);
    }

    // Brak własnego koloru => domyślny success z motywu, ale przezroczystość
    // ustawiona przez organizatora działa dokładnie tak samo.
    const channels = userColorPrimary ? rgbChannels(userColorPrimary) : 'var(--vz-success-rgb)';

    // Kolor eventu steruje tłem ORAZ obramowaniem paska wydarzenia (accordionu).
    // Nie dotyka przycisków, tekstu itd. — te zostają na domyślnym motywie.
    styleElement.textContent = `
      .bg-color-primary-subtle {
        background-color: rgba(${channels}, ${opacity}) !important;
        border: 2px solid rgba(${channels}, ${borderAlpha}) !important;
      }
    `;

    // Cleanup przy unmount
    return () => {
      const element = document.getElementById('user-custom-colors');
      if (element) {
        element.remove();
      }
    };
  }, [userColorPrimary, userColorOpacity]);
};

// Zwraca kanały "r, g, b" gotowe do wstawienia w rgba(); przy błędnym hexie
// spada na domyślny success motywu, żeby nie wyczernić paska.
const rgbChannels = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return 'var(--vz-success-rgb)';

  return `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}`;
};
